import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Marketing Postcards </h1>

    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/postcards/jumoPostcardsGrid.png')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed postcards for an educational pediatrics healthcare company to help the general public and the company's users be 
    aware of the varying forms of content offered as well as the new membership website being offered. The goal 
    in my designs was to maintain the company's current branding style, as well as create a theme of fun and youthfulness 
    for the young target audience.</p>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.